import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/driver-recruitment',
    name: 'driverRecruitment',
    component: () => import('../views/driverRecruitment.vue')
  },
  {
    path: '/partner-recruitment',
    name: 'partnerRecruitment',
    component: () => import('../views/partnerRecruitment.vue')
  },
  {
    path: '/join-us',
    name: 'joinUs',
    component: () => import('../views/joinUs.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
